﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const form_controls_1 = require("@its-suite/form-controls");
const app_commons_1 = require("@its-suite/app-commons");
class OrganizationHelpers {
    static getOrganizationSelectOptions(organizations, allowedOrganizations, includeDepartments, purgeDisabledNodes) {
        let result = [];
        this.sortOrganizations(organizations).forEach(company => {
            let suboptions = [];
            if (includeDepartments !== false) {
                this.sortOrganizations(company.departments).forEach(dept => {
                    let suboption = this.getDepartmentOptions(dept, allowedOrganizations, purgeDisabledNodes);
                    if (!purgeDisabledNodes || !suboption.disabled || suboption.suboptions.length > 0) {
                        suboptions.push(suboption);
                    }
                });
            }
            let disabled = allowedOrganizations.indexOf(company.appId) === -1;
            if (!purgeDisabledNodes || !disabled || suboptions.length > 0) {
                result.push({ value: company.appId, text: company.name, suboptions: suboptions, disabled: disabled });
            }
        });
        return result;
    }
    static mapDepartmentsToSelectOptions(departments) {
        let result = [];
        let suboptions = [];
        this.sortOrganizations(departments).forEach(dept => {
            if (dept.departments) {
                suboptions = this.mapDepartmentsToSelectOptions(dept.departments);
            }
            let option = {
                value: dept.appId,
                text: dept.name,
                suboptions: suboptions
            };
            result.push(option);
        });
        return result;
    }
    static getCompanyAppIdOfOrganization(organizationAppId, companies) {
        return companies.map(c => c.appId).indexOf(organizationAppId) >= 0
            ? organizationAppId
            : this.getCompanyAppIdOfDepartment(organizationAppId, companies);
    }
    static isDepartmentAppIdInSubdepartments(departmentAppId, organization) {
        if (organization.departments) {
            for (let d of organization.departments) {
                if (d.appId === departmentAppId || this.isDepartmentAppIdInSubdepartments(departmentAppId, d)) {
                    return true;
                }
            }
        }
        return false;
    }
    static getOrganizationName(organizationAppId, organizations) {
        let organization = this.getOrganization(organizationAppId, organizations);
        let organizationName = organization === null || organization === void 0 ? void 0 : organization.name;
        return organizationName !== null && organizationName !== void 0 ? organizationName : '';
    }
    static getOrganization(organizationAppId, organizations) {
        let foundOrganization;
        for (let org of organizations) {
            if (org.appId === organizationAppId) {
                foundOrganization = org;
                break;
            }
            else {
                let departmentOrganization = this.getOrganization(organizationAppId, org.departments);
                if (departmentOrganization) {
                    foundOrganization = departmentOrganization;
                    break;
                }
            }
        }
        return foundOrganization;
    }
    static normalizeOrganizationAppIdForSelect(organizationAppId) {
        return organizationAppId === app_commons_1.Constants.GLOBAL_ORGANIZATION_APPID ? app_commons_1.Constants.GLOBAL_ORGANIZATION_APPID_VALUE_FOR_SELECTS : organizationAppId;
    }
    static getAllOrganizationAppIds(organizations) {
        let organizationAppIds = [];
        for (let organization of organizations) {
            organizationAppIds.push(organization.appId);
            if (organization.departments) {
                organizationAppIds.push(...this.getAllOrganizationAppIds(organization.departments));
            }
        }
        return organizationAppIds;
    }
    static getParentOrganizationAppIds(organizationAppId, organizations) {
        let organizationHierarchy = organizations.find(o => this.isInHierarchy(o, organizationAppId));
        return this.getAncestorsOrganizationAppIds(organizationHierarchy, organizationAppId);
    }
    static getDescendantOrganizations(organization) {
        var _a;
        const result = [organization.appId];
        const normalizedDepartments = (_a = organization.departments) !== null && _a !== void 0 ? _a : [];
        for (let childDepartment of normalizedDepartments) {
            result.push(...OrganizationHelpers.getDescendantOrganizations(childDepartment));
        }
        return result;
    }
    static isInHierarchy(organization, organizationAppId) {
        var _a;
        return (_a = organization.departments) === null || _a === void 0 ? void 0 : _a.some(d => d.appId === organizationAppId || this.isInHierarchy(d, organizationAppId));
    }
    static getAncestorsOrganizationAppIds(organization, organizationAppId) {
        let ancestorOrgAppIds = [];
        let parentOrgAppId = this.getParentOrgAppId(organization, organizationAppId);
        if (parentOrgAppId) {
            ancestorOrgAppIds.push(parentOrgAppId);
            ancestorOrgAppIds.push(...this.getAncestorsOrganizationAppIds(organization, parentOrgAppId));
        }
        return ancestorOrgAppIds;
    }
    static getParentOrgAppId(organization, organizationAppId) {
        let parentOrgAppId;
        if (organization && this.isInHierarchy(organization, organizationAppId)) {
            parentOrgAppId = this.recursivelyGetParentOrgAppId(organization, organizationAppId);
        }
        return parentOrgAppId;
    }
    static recursivelyGetParentOrgAppId(organization, organizationAppId) {
        while (organization.departments && !organization.departments.some(d => d.appId === organizationAppId)) {
            let targetBranch = organization.departments.find(d => this.isInHierarchy(d, organizationAppId));
            if (targetBranch) {
                organization = targetBranch;
            }
        }
        return organization.appId;
    }
    static getCompanyAppIdOfDepartment(departmentAppId, companies) {
        for (let c of companies) {
            if (c.departments) {
                for (let d of c.departments) {
                    if (d.appId === departmentAppId || this.isDepartmentAppIdInSubdepartments(departmentAppId, d)) {
                        return c.appId;
                    }
                }
            }
        }
        return '';
    }
    static getDepartmentOptions(department, allowedOrganizations, purgeDisabledNodes) {
        let suboptions = [];
        if (department.departments) {
            this.sortOrganizations(department.departments).forEach(dept => {
                let suboption = this.getDepartmentOptions(dept, allowedOrganizations, purgeDisabledNodes);
                if (!purgeDisabledNodes || !suboption.disabled || suboption.suboptions.length > 0) {
                    suboptions.push(suboption);
                }
            });
        }
        return {
            value: department.appId,
            text: department.name,
            suboptions: suboptions,
            disabled: allowedOrganizations.indexOf(department.appId) === -1
        };
    }
    static sortOrganizations(organizations) {
        return [...organizations].sort((o1, o2) => form_controls_1.StringHelpers.compareStrings(o1.name, o2.name));
    }
}
exports.OrganizationHelpers = OrganizationHelpers;
OrganizationHelpers.maxOrganizationAppIdLength = 5;
//# sourceMappingURL=OrganizationHelpers.js.map